import React from "react";
import AboutboxImg from '../../assets/about-image.webp';

const AboutUs = () => {

    return (<>
       <section className="about_section-2">
            <div className="container">
                <div className="row justify-content-center align-items-center">
                    <div className="col-lg-6 col-md-10 about-col-text text-left">
                        <h6>Emergency Roadside Assistance</h6>
                        <h3>We Are Here to Help — Anytime, Anywhere</h3>
                        {/*<h4>Stay Updated And Ready For Any Emergency With Truck Repair Services As Your Companion.</h4> */}
                        <p>When you're stuck on the road, we understand the urgency and stress.
                            Whether it's a tire blowout, a reefer malfunction, or you're simply
                            searching for the nearest truck stop — Truck Repair Shop is your
                            go-to platform. We connect you instantly with trusted service
                            providers for truck and trailer repair, emergency fixes, and
                            routine maintenance. No matter where you are, help is just a
                            click away. </p>

                        <div className="about_feature_list">
                             <h5>What We Offer</h5>
                             <ul>
                                <li>
                                 <h6>Tire Blowout Support</h6>
                                 <p>Immediate help when your tires give out get rolling again fast.</p>
                                </li>
                                <li>
                                 <h6>Emergency Reefer Repair</h6>
                                 <p>Keep your cargo safe and temperature controlled with rapid reefer service.</p>
                                </li>
                                <li>
                                 <h6>Nearest Truck Stop Locator</h6>
                                 <p>Find fuel, rest, and essentials wherever you're stranded.</p>
                                </li>
                                <li>
                                 <h6>Breakdown Recovery</h6>
                                 <p>From minor issues to major breakdowns, we’ve got your back.</p>
                                </li>
                             </ul>

                        </div>
                    </div>

                    <div className="col-md-6 d-lg-block d-none">
                        <div className="about_img_box">
                            <img src={AboutboxImg} className='img-fluid' alt='Stuck-in-an-emergency' loading='lazy'/>
                        </div>
                    </div>

                </div>
            </div>
        </section>

        <section className="about_section-1">
            <div className="container">
                <div className="row justify-content-center">
                    <div className="section-title col-md-12 mb-lg-5 mb-2 pb-3">
                        <h2>How can we make things easier for you?</h2>
                        <p>Reliable support whenever and wherever you need it.</p>
                    </div>

                    <div className="col-lg-4 col-md-6 mb-2 mb-md-0">
                        <div className="about_service h-100">
                            <div className="ico-high bg-light-yellow">
                                <i className="fa fa-cogs" title="choose-your-service"></i>
                            </div>
                            <div className="about-service-text">
                            <h2>Choose your service</h2>
                            <p>Truck repairs, towing, or trailer fixes —
                                Truck Repair Shop will deliver fast, reliable
                                roadside assistance to quickly reduce your downtime.</p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-6 mb-2 mb-md-0">
                        <div className="about_service h-100">
                            <div className="ico-high bg-light-red">
                                <i className="fa fa-street-view" title="where-you-are"></i>
                            </div>
                            <div className="about-service-text">
                            <h2>Where you are?</h2>
                            <p>
                            Choose your location, and Truck Repair Shop
                            connects you with trusted truck repair providers
                            nationwide to keep you moving.
                            </p>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4 col-md-12 mb-2 mb-md-0">
                        <div className="about_service h-100">
                            <div className="ico-high bg-light-green">
                                <i className="fa fa-flag" title="suits-you-the-best"></i>
                            </div>
                            <div className="about-service-text">
                            <h2>Suits you the best</h2>
                            <p>
                            Truck Repair Shop lists nearby repair providers
                            with key details, helping you quickly choose the
                            right option for any truck repair or towing need.
                            </p>
                            </div>
                        </div>
                    </div>

                </div>
            </div>
        </section>

    </>
    );
};

export default AboutUs;